// Атрибуты квизовой практики. Как и у карточек, бэкенд опознаёт практику по тройке
// practiceType/practiceFormat/learningMethod, поэтому значения обязаны совпадать
// у инициализации практики и у запроса прогресса по квизам.
export const QUIZ_PRACTICE_TYPE = 'QUIZ';
// Не самооценка: человек выбирает из готовых вариантов, а проверяет ответ машина.
// Прежнее имя копилось в журнале неверным и стоило веса — поправка на угадывание
// спасала только потому, что смотрит на число вариантов, а не на имя формата.
// Существующие документы переименовывает 2026-09-05-quiz-format-multiple-choice.js,
// и он обязан пройти раньше выката этого значения.
export const QUIZ_PRACTICE_FORMAT = 'MULTIPLE_CHOICE_QUIZ';
export const QUIZ_LEARNING_METHOD = 'MASTERY_RULE';
